export default __webpack_public_path__ + "static/122-18b2aa01c65143f928a2131b8b678e60.jpg";